import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { SuccessModalProvider } from "./context/SuccessModalProvider";
import { Provider } from "react-redux";
import { persistor, store } from "./redux/store";
import { PersistGate } from "redux-persist/integration/react";
import { ConfigProvider } from "antd";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <BrowserRouter>
        <SuccessModalProvider>
          <ConfigProvider
            theme={{
              token: {
                colorPrimary: "#a33434",
                colorSecondary: "#a33434",
                colorBackground: "#a33434",
                colorTextPrimary: "#a33434",
                colorTextSecondary: "#a33434",
                colorLink: "#a33434",
              },
            }}
          >
            <App />
          </ConfigProvider>
        </SuccessModalProvider>
      </BrowserRouter>
    </PersistGate>
  </Provider>,
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
